module.exports = __webpack_public_path__ + "img/alipay.e1912a63.svg";